import { jsx as n } from "react/jsx-runtime";
const u = (a) => {
  const { spacing: e, children: t, testId: r } = a, s = [];
  switch (e) {
    case "bottom":
      s.push("u-sm-marginBottom32"), s.push("u-marginBottom48");
      break;
    case "top":
      s.push("u-sm-marginTop32"), s.push("u-marginTop48");
      break;
    case "full":
      s.push("u-sm-marginVert32"), s.push("u-marginVert48");
      break;
  }
  return s.length === 0 ? t : /* @__PURE__ */ n(
    "div",
    {
      className: s.join(" "),
      "data-testid": r ? `${r}-wrapper` : null,
      children: t
    }
  );
};
export {
  u as Spacer
};
//# sourceMappingURL=Spacer.mjs.map
